<ng-container *ngIf="remote?.isNotAsked()">
  <ng-container *ngTemplateOutlet="notAskedTemplate"></ng-container>
</ng-container>
<ng-container *ngIf="remote?.isLoading()">
  <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
</ng-container>
<ng-container *ngIf="remote?.isFailure()">
  <ng-container *ngTemplateOutlet="failureTemplate; context: { $implicit: asFailure(remote)._error }"></ng-container>
</ng-container>
<ng-container *ngIf="remote?.isSuccess()">
  <ng-container *ngIf="!isEmpty(asSuccess(remote)._data); else emptyData">
    <ng-container *ngTemplateOutlet="successTemplate; context: { $implicit: asSuccess(remote)._data }"></ng-container>
  </ng-container>
</ng-container>
<ng-template #emptyData>
  <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
</ng-template>
